// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./images/background/bg.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes style_spin__rSIP4 {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.style_app__h3GCi {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  width: 100%;
  align-items: center;
  background-color: #f2f4f7;
}
.style_app__h3GCi .style_formMain__TBVto {
  position: relative;
  z-index: 2;
  max-width: 1920rem;
  width: 100%;
  display: flex;
  flex-direction: column;
  overflow: visible;
}
.style_app__h3GCi .style_formMain__TBVto .style_pattern__1W5Ax {
  position: absolute;
  right: -53rem;
  top: -40%;
  z-index: -1;
}
.style_app__h3GCi .style_main__PT5UG {
  position: relative;
  max-width: 1920rem;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: visible;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  background-position: center center;
}
.style_app__h3GCi .style_main__PT5UG .style_bgImages__bVs6o {
  display: flex;
  width: 100%;
  height: 100%;
  position: absolute;
}
.style_app__h3GCi .style_main__PT5UG .style_bgImages__bVs6o .style_leftSpiral__Ke7CZ {
  width: 747rem;
  height: 643rem;
  top: -316rem;
  left: -276rem;
  position: absolute;
  animation: style_spin__rSIP4 60s linear infinite;
}
@media only screen and (max-width: 700px) {
  .style_app__h3GCi .style_main__PT5UG .style_bgImages__bVs6o .style_leftSpiral__Ke7CZ {
    width: 332rem;
    height: 332rem;
    top: -111rem;
    left: -150rem;
  }
}
.style_app__h3GCi .style_main__PT5UG .style_bgImages__bVs6o .style_rightSpiral__eCIdZ {
  width: 739rem;
  height: 928rem;
  right: -254rem;
  position: absolute;
  top: -31rem;
  animation: style_spin__rSIP4 60s linear infinite;
}
@media only screen and (max-width: 700px) {
  .style_app__h3GCi .style_main__PT5UG .style_bgImages__bVs6o .style_rightSpiral__eCIdZ {
    top: 330rem;
    right: -164rem;
    width: 444rem;
    height: 372rem;
  }
}
.style_app__h3GCi .style_main__PT5UG .style_container__GCvyz {
  position: relative;
  z-index: 2;
  flex-direction: column;
  width: 100%;
  height: 100%;
}
.style_app__h3GCi .style_main__PT5UG .style_container__GCvyz .style_informationContainer__kT5FM {
  position: relative;
  margin-top: 34rem;
}
@media only screen and (max-width: 700px) {
  .style_app__h3GCi .style_main__PT5UG .style_container__GCvyz .style_informationContainer__kT5FM {
    margin-top: 32rem;
  }
}
.style_app__h3GCi .style_main__PT5UG .style_container__GCvyz .style_informationContainer__kT5FM .style_mainImage__\\+eSsG {
  width: 881rem;
  height: 625rem;
  position: absolute;
  display: inline-block;
  top: 8rem;
  right: 67rem;
  bottom: 0;
  left: auto;
}
@media only screen and (max-width: 700px) {
  .style_app__h3GCi .style_main__PT5UG .style_container__GCvyz .style_informationContainer__kT5FM .style_mainImage__\\+eSsG {
    width: 100%;
    height: auto;
    aspect-ratio: 881/625;
    left: 40rem;
    top: 220rem;
    animation: none;
  }
}
.style_app__h3GCi .style_main__PT5UG .style_container__GCvyz .style_informationContainer__kT5FM .style_companyInfo__pN2fi {
  z-index: 0;
  padding-left: 48rem;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: fit-content;
  gap: 24rem;
}
@media only screen and (max-width: 700px) {
  .style_app__h3GCi .style_main__PT5UG .style_container__GCvyz .style_informationContainer__kT5FM .style_companyInfo__pN2fi {
    width: 390rem;
    padding-left: 16rem;
    gap: 16rem;
  }
}
.style_app__h3GCi .style_main__PT5UG .style_container__GCvyz .style_informationContainer__kT5FM .style_companyInfo__pN2fi .style_name__QY58X {
  width: 100%;
  height: fit-content;
  font-family: "Vivl Rail", sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 132rem;
  line-height: 132rem;
  color: #47C4F0;
}
@media only screen and (max-width: 700px) {
  .style_app__h3GCi .style_main__PT5UG .style_container__GCvyz .style_informationContainer__kT5FM .style_companyInfo__pN2fi .style_name__QY58X {
    font-family: "Vivl Rail", sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 54rem;
    line-height: 56rem;
    color: #47C4F0;
  }
}
.style_app__h3GCi .style_main__PT5UG .style_container__GCvyz .style_informationContainer__kT5FM .style_companyInfo__pN2fi .style_description__sTwGb {
  width: fit-content;
  height: fit-content;
  max-width: 900rem;
  font-family: "Roboto", sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 32rem;
  line-height: 42rem;
  color: #1d2939;
}
@media only screen and (max-width: 700px) {
  .style_app__h3GCi .style_main__PT5UG .style_container__GCvyz .style_informationContainer__kT5FM .style_companyInfo__pN2fi .style_description__sTwGb {
    font-family: "Roboto", sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 20rem;
    line-height: 28rem;
    color: #1d2939;
  }
}`, "",{"version":3,"sources":["webpack://./src/style.module.scss","webpack://./src/styles/_variables.scss","webpack://./src/styles/_mixins.scss"],"names":[],"mappings":"AAGA;EACE;IACE,uBAAA;EAFF;EAIA;IACE,yBAAA;EAFF;AACF;AAKA;EACE,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,yBCZS;ADSX;AAKE;EACE,kBAAA;EACA,UAAA;EACA,kBAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,iBAAA;AAHJ;AAOI;EACE,kBAAA;EACA,aAAA;EACA,SAAA;EACA,WAAA;AALN;AAQE;EACE,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,iBAAA;EACA,yDAAA;EACA,sBAAA;EACA,kCAAA;AANJ;AAQI;EACE,aAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;AANN;AAQM;EACE,aAAA;EACA,cAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EAEA,gDAAA;AAPR;AEkFE;EFlFI;IAUI,aAAA;IACA,cAAA;IACA,YAAA;IACA,aAAA;EANR;AACF;AASM;EACE,aAAA;EACA,cAAA;EACA,cAAA;EACA,kBAAA;EACA,WAAA;EACA,gDAAA;AAPR;AEkEE;EFjEI;IASI,WAAA;IACA,cAAA;IACA,aAAA;IACA,cAAA;EANR;AACF;AAWI;EACE,kBAAA;EACA,UAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;AATN;AAWM;EACE,kBAAA;EACA,iBAAA;AATR;AE+CE;EFxCI;IAKI,iBAAA;EARR;AACF;AAUQ;EACE,aAAA;EACA,cAAA;EACA,kBAAA;EACA,qBAAA;EAEA,SAAA;EACA,YAAA;EACA,SAAA;EACA,UAAA;AATV;AEgCE;EFhCM;IAcI,WAAA;IACA,YAAA;IACA,qBAAA;IACA,WAAA;IACA,WAAA;IAEA,eAAA;EAXV;AACF;AAcQ;EACE,UAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EAEA,WAAA;EACA,mBAAA;EACA,UAAA;AAbV;AEaE;EFRM;IAWI,aAAA;IACA,mBAAA;IACA,UAAA;EAZV;AACF;AAcU;EACE,WAAA;EACA,mBAAA;EEjJV,oCDHW;ECIX,kBAAA;EACA,gBFiJwC;EEhJxC,iBAAA;EACA,mBAAA;EACA,cDSK;AD6HP;AEJE;EFQQ;IE/IR,oCDHW;ICIX,kBAAA;IACA,gBFoJwC;IEnJxC,gBAAA;IACA,kBAAA;IACA,cDSK;EDsIL;AACF;AAKU;EACE,kBAAA;EACA,mBAAA;EACA,iBAAA;EE7JV,iCDFU;ECGV,kBAAA;EACA,gBF6J0C;EE5J1C,gBAAA;EACA,kBAAA;EACA,cDKS;ADsJX;AEzBE;EFmBQ;IE1JR,iCDFU;ICGV,kBAAA;IACA,gBFgK4C;IE/J5C,gBAAA;IACA,kBAAA;IACA,cDKS;ED+JT;AACF","sourcesContent":["@use \"/src/styles/mixins\" as *;\n@use \"/src/styles/variables\" as *;\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n.app {\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  width: 100%;\n  align-items: center;\n  background-color: $gray-100;\n\n  .formMain {\n    position: relative;\n    z-index: 2;\n    max-width: 1920rem;\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    overflow: visible;\n    //background-image: url(\"images/background/bg.svg\");\n    //background-size: cover;\n    //background-position: center center;\n    .pattern {\n      position: absolute;\n      right: -53rem;\n      top: -40%;\n      z-index: -1;\n    }\n  }\n  .main {\n    position: relative;\n    max-width: 1920rem;\n    width: 100%;\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    overflow: visible;\n    background-image: url(\"images/background/bg.svg\");\n    background-size: cover;\n    background-position: center center;\n\n    .bgImages {\n      display: flex;\n      width: 100%;\n      height: 100%;\n      position: absolute;\n\n      .leftSpiral {\n        width: 747rem;\n        height: 643rem;\n        top: -316rem;\n        left: -276rem;\n        position: absolute;\n\n        animation: spin 60s linear infinite;\n\n        @include mobile {\n          width: 332rem;\n          height: 332rem;\n          top: -111rem;\n          left: -150rem;\n        }\n      }\n\n      .rightSpiral {\n        width: 739rem;\n        height: 928rem;\n        right: -254rem;\n        position: absolute;\n        top: -31rem;\n        animation: spin 60s linear infinite;;\n\n        @include mobile {\n          top: 330rem;\n          right: -164rem;\n          width: 444rem;\n          height: 372rem;\n        }\n\n      }\n    }\n\n    .container {\n      position: relative;\n      z-index: 2;\n      flex-direction: column;\n      width: 100%;\n      height: 100%;\n\n      .informationContainer {\n        position: relative;\n        margin-top: 34rem;\n\n        @include mobile {\n          margin-top: 32rem;\n        }\n\n        .mainImage {\n          width: 881rem;\n          height: 625rem;\n          position: absolute;\n          display: inline-block;\n\n          top: 8rem;\n          right: 67rem;\n          bottom: 0;\n          left: auto;\n\n          //animation: moveUpDown 6s ease-in-out infinite;\n\n          @include mobile {\n            width: 100%;\n            height: auto;\n            aspect-ratio: 881 / 625;\n            left: 40rem;\n            top: 220rem;\n\n            animation: none;\n          }\n        }\n\n        .companyInfo {\n          z-index: 0;\n          padding-left: 48rem;\n          display: flex;\n          flex-direction: column;\n\n          width: 100%;\n          height: fit-content;\n          gap: 24rem;\n\n          @include mobile {\n            width: 390rem;\n            padding-left: 16rem;\n            gap: 16rem;\n          }\n\n          .name {\n            width: 100%;\n            height: fit-content;\n\n            @include fnt(132, 132, $main, 400, $font-title);\n\n            @include mobile {\n              @include fnt(54, 56, $main, 400, $font-title);\n            }\n          }\n\n          .description {\n            width: fit-content;\n            height: fit-content;\n            max-width: 900rem;\n\n            @include fnt(32, 42, $gray-800, 400);\n\n            @include mobile {\n              @include fnt(20, 28, $gray-800, 400);\n            }\n          }\n        }\n      }\n    }\n  }\n}","$font-title: \"Vivl Rail\", sans-serif;\n$font-text: \"Roboto\", sans-serif;\n\n$gray-20: #f9f9fa;\n$gray-25: #fcfcfd;\n$gray-50: #f9fafb;\n$gray-100: #f2f4f7;\n$gray-200: #eaecf0;\n$gray-300: #d0d5dd;\n$gray-400: #98a2b3;\n$gray-500: #667085;\n$gray-600: #475467;\n$gray-700: #344054;\n$gray-800: #1d2939;\n$gray-900: #101828;\n$gray-950: #0C111D;\n\n$main: #47C4F0;\n\n$error-50: #FEF3F2;\n$error-100: #FEE4E2;\n$error-200: #FECDCA;\n$error-300: #FDA29B;\n$error-400: #F97066;\n$error-500: #F04438;\n$error-600: #D92D20;\n\n$green: #17B26A;\n$red: #F04438;\n$orange: #F79009;\n\n$success: $green;\n$error: $red;\n$warning: $orange;\n\n$black: $gray-900;\n$white: #ffffff;\n$text-gray: $gray-500;\n$text-color: #2c2d2e;\n$text-color-secondary: $text-gray;\n$border: $gray-300;\n\n$mobile-width: 700;\n$tablet-width: 1024;\n$laptop-width: 1440;\n$hd: 1680;\n$hd-width: 1920;\n\n$main-container: 1824;\n\n$tr: 0.2s ease-out;","@use \"variables\" as *;\n\n@mixin fnt($size: 16, $height: 24, $color: $black, $weight: 400, $font: $font-text, $unit: \"rem\") {\n  font-family: $font;\n  font-style: normal;\n  font-weight: $weight;\n  font-size: #{$size}#{$unit};\n  line-height: #{$height}#{$unit};\n  color: $color;\n}\n\n@mixin scrollable {\n  display: flex;\n  overflow-x: auto;\n\n  gap: 24rem;\n  margin-top: 32rem;\n  padding: 0 48rem;\n\n  @media(min-width: #{$main-container + 1}px) {\n    padding: 0 calc((100vw - #{$main-container}px) / 2);\n  }\n\n  @include mobile {\n    margin-top: 16rem;\n    gap: 16rem;\n    padding: 0 16rem;\n  }\n}\n\n@mixin container($margin: 124rem auto) {\n  margin: $margin;\n  width: 100%;\n  padding: 0 48px;\n  @media (min-width: #{$main-container + 1}px) {\n    width: #{$main-container + 32}px;\n\n  }\n  @include mobile {\n    padding: 0 16rem;\n  }\n}\n\n@mixin scrollButtonContainer {\n  display: flex;\n  flex-direction: row;\n  align-items: flex-end;\n  justify-content: end;\n  height: fit-content;\n  width: fit-content;\n  gap: 16rem;\n\n  @include mobile {\n    display: none;\n  }\n}\n\n@mixin sectionHeader {\n  display: inline;\n  gap: 24rem;\n\n  img {\n    height: 68rem;\n    width: 68rem;\n    margin-right: 12rem;\n    @include mobile {\n      height: 42rem;\n      width: 42rem;\n    }\n  }\n\n  @include fnt(72, 82, $gray-800, 400, $font-title);\n  @include mobile {\n    @include fnt(32, 42, $gray-800, 400, $font-title);\n  }\n}\n\n@mixin header {\n  width: 100%;\n  padding: 0 48rem;\n  height: fit-content;\n  @include sectionHeader;\n  @include mobile {\n    padding: 0 16rem;\n  }\n  @content\n}\n\n@mixin textToMobile {\n  @include fnt(20, 24, $gray-400, 400, $font-text);\n  @include mobile {\n    @include fnt(16, 20, $gray-400, 400, $font-text);\n  }\n}\n\n@mixin inputField {\n  border-radius: 12rem;\n  padding: 16rem 20rem;\n\n  background-color: $white;\n  border: 1px $gray-300 solid;\n\n  @include mobile {\n    padding: 12rem 16rem;\n  }\n\n  @include textToMobile;\n\n  &::placeholder {\n    @include textToMobile;\n  }\n\n  * {\n    @include textToMobile;\n  }\n\n  &:active {\n    border: 1px $gray-700, solid;\n  }\n\n  &:hover {\n    border: 1px $gray-400, solid;\n  }\n\n  &error {\n    @include fnt(16, 24, $error-300, 500, $font-text);\n    @include mobile {\n      @include fnt(12, 24, $error-300, 500, $font-text);\n    }\n    border: 1px $error-500, solid;\n\n    * {\n      color: $error-300;\n    }\n  }\n}\n\n@mixin mobile {\n  @media only screen and (max-width: #{$mobile-width}px) {\n    @content;\n  }\n}\n\n@mixin laptop {\n  @media only screen and (max-width: #{$laptop-width}px) {\n    @content;\n  }\n}\n\n@mixin tablet {\n  @media only screen and (max-width: #{$tablet-width}px) {\n    @content;\n  }\n}\n\n@mixin hd {\n  @media only screen and (max-width: #{$hd-width}px) {\n    @content;\n  }\n}\n\n@mixin hd-plus {\n  @media only screen and (min-width: #{$hd-width}px) {\n    @content;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"app": `style_app__h3GCi`,
	"formMain": `style_formMain__TBVto`,
	"pattern": `style_pattern__1W5Ax`,
	"main": `style_main__PT5UG`,
	"bgImages": `style_bgImages__bVs6o`,
	"leftSpiral": `style_leftSpiral__Ke7CZ`,
	"spin": `style_spin__rSIP4`,
	"rightSpiral": `style_rightSpiral__eCIdZ`,
	"container": `style_container__GCvyz`,
	"informationContainer": `style_informationContainer__kT5FM`,
	"mainImage": `style_mainImage__+eSsG`,
	"companyInfo": `style_companyInfo__pN2fi`,
	"name": `style_name__QY58X`,
	"description": `style_description__sTwGb`
};
export default ___CSS_LOADER_EXPORT___;
